import { CALL_API } from "redux-api-middleware";
import api from "apis/layout";
import {
  REQUEST_SIDEBAR,
  RECEIVE_SIDEBAR,
  ERROR_SIDEBAR,
  TOGGLE_MENU_ITEM,
  TOGGLE_CASE_MENU_ITEM,
  ALL_CARDS_EXPANDED,
  RESIZE_REQUIRED,
  RESIZE_COMPLETE,
  SIDEBAR_EXPAND, SIDEBAR_CONTRACT,
  TOGGLE_ACTIVE_SIDEBAR_MODULE,
  UPDATE_HEADER,
  CLEAR_HEADER,
  APPEND_HEADER,
  CLEAR_HEADER_DEFINITIONS,
  TOGGLE_WINDOW,
  CLOSE_WINDOW,
  CORELAYOUT_HEADER_VISIBILITY_CHANGE,
  CORELAYOUT_SIDEBAR_VISIBILITY_CHANGE,
} from "typeConstants";

import responseHandler from "responseHandler";

const getSidebar = () => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.getSidebar(),
        method: "GET",
        types: [
          REQUEST_SIDEBAR,
          {
            type: RECEIVE_SIDEBAR,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_SIDEBAR,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    })
  );
};

const allCardsExpanded = (val) => {
  return dispatch => {
    dispatch({
      type: ALL_CARDS_EXPANDED,
      payload: { value: val }
    }).then(() => setTimeout(() => {
      // ToDo: Fix this to be dispatched 
      // when all forms are open. 
      dispatch({
        type: ALL_CARDS_EXPANDED,
        payload: { value: null }
      });
    }, 3000));
  };
};

const toggleMenuItem = (menuId) => ({
  type: TOGGLE_MENU_ITEM,
  menuId
});

const toggleCaseMenuItem = (menuId) => ({
  type: TOGGLE_CASE_MENU_ITEM,
  menuId
});

const resizeRequired = () => {
  return dispatch => (
    dispatch({
      type: RESIZE_REQUIRED,
      payload: true
    }));
};

const resizeComplete = () => {
  return dispatch => (
    dispatch({
      type: RESIZE_COMPLETE,
      payload: false
    }));
};

const sidebarExpand = () => {
  return dispatch => (
    dispatch({
      type: SIDEBAR_EXPAND,
    }));
};

const sidebarContract = () => {
  return dispatch => (
    dispatch({
      type: SIDEBAR_CONTRACT,
    }));
};

const toggleActiveModule = (id) => {
  return dispatch => (
    dispatch({
      type: TOGGLE_ACTIVE_SIDEBAR_MODULE,
      payload: id,
    }));
  };
  
const updateHeader = (headerDefinitions) => {
  return dispatch => (dispatch({
    type: UPDATE_HEADER,
    payload: headerDefinitions,
  }));
};

const clearHeader = () => {
  return dispatch => (dispatch({
    type: CLEAR_HEADER,
  }));
};

const appendHeader = (headerDefinitions) => {
  return dispatch => (dispatch({
    type: APPEND_HEADER,
    payload: headerDefinitions,
  }));
};

const clearHeaderDefinitions = (headerDefinitions) => {
  return dispatch => (dispatch({
    type: CLEAR_HEADER_DEFINITIONS,
    payload: headerDefinitions,
  }));
};

const toggleWindow = windowDefs => ({
  type: TOGGLE_WINDOW,
  payload: windowDefs,
});

const closeWindow = windowDefs => ({
  type: CLOSE_WINDOW,
  payload: windowDefs,
});

const setCoreLayoutHeaderVisibility = payload => ({
  type: CORELAYOUT_HEADER_VISIBILITY_CHANGE,
  payload
});

const setCoreLayoutSidebarVisibility = payload => ({
  type: CORELAYOUT_SIDEBAR_VISIBILITY_CHANGE,
  payload
});

export {
  getSidebar,
  toggleMenuItem,
  toggleCaseMenuItem,
  allCardsExpanded,
  resizeRequired,
  resizeComplete,
  sidebarExpand,
  sidebarContract,
  toggleActiveModule,
  updateHeader,
  clearHeader,
  appendHeader,
  clearHeaderDefinitions,
  toggleWindow,
  closeWindow,
  setCoreLayoutHeaderVisibility,
  setCoreLayoutSidebarVisibility,
};
